const CustomInput = ({
  label,
  labelClassName = '',
  value,
  onChange,
  type = 'text',
  placeholder = '',
  icon: IconComponent,
  required = false,
  disabled = false,
  readOnly = false,
  mono = false,
  min,
  max,
  maxLength,
  title,
  className = '',
  inputClassName = '',
  autoFocus = false,
  id,
  name,
  onKeyDown,
  onBlur,
  onFocus
}) => {
  const isRequired = required || (typeof label === 'string' && label.includes('*'));
  const cleanLabel = typeof label === 'string' ? label.replace('*', '').trim() : label;

  return (
    <div className={`w-full ${className}`}>
      {label && (
        <label className={`block text-xs mb-1.5 ${labelClassName || 'font-medium text-slate-600'}`}>
          {cleanLabel} {isRequired && <span className="text-rose-500 ml-0.5">*</span>}
        </label>
      )}
      <div className="relative flex items-center">
        {IconComponent && (
          <div className="absolute left-3.5 text-slate-400 pointer-events-none flex items-center justify-center">
            <IconComponent size={16} />
          </div>
        )}
        <input
          id={id}
          name={name}
          type={type}
          value={value ?? ''}
          onChange={onChange}
          placeholder={placeholder}
          disabled={disabled}
          readOnly={readOnly}
          min={min}
          max={max}
          maxLength={maxLength}
          title={title}
          autoFocus={autoFocus}
          onKeyDown={onKeyDown}
          onBlur={onBlur}
          onFocus={onFocus}
          className={`w-full bg-white border border-slate-200 focus:border-primary focus:ring-1 focus:ring-primary rounded-xl text-xs sm:text-sm font-normal text-slate-700 transition-all outline-none shadow-sm h-[42px] ${
            IconComponent ? 'pl-10 pr-3.5' : 'px-4'
          } ${
            mono ? 'font-mono text-primary font-medium' : ''
          } ${
            disabled || readOnly ? 'bg-slate-100/80 cursor-not-allowed text-slate-500 select-none' : ''
          } ${inputClassName}`}
        />
      </div>
    </div>
  );
};

export default CustomInput;
